import Logo from 'assets/images/logo-med-tekst.png';
import SponsorLogo from 'assets/images/ny-logo-sparebank1.png';
import { Anchor, Box, Footer, Image } from 'grommet';
import useResponsive from 'hooks/useResponsive';
import React from 'react';
import styled from 'styled-components';
import { appRouteItems } from '../appRouteItems';
import { LinkItem } from './LinkItem';

const StyledLinkItem = styled(LinkItem)`
  font-weight: 200;
  color: #002776;
`;

const ContentFooter = () => {
  const { isMobile } = useResponsive();
  return (
    <Footer background="SkyBlue" pad="large" justify="between" wrap gap="medium">
      <Box direction="row-responsive" gap="xsmall">
        <Box align="center" gap="small" direction={isMobile ? 'column' : 'row'}>
          <LinkItem route="/">
            <Box height={isMobile ? 'xsmall' : 'small'} width={isMobile ? 'xsmall' : 'small'}>
              <Image fit="contain" src={Logo} />
            </Box>
          </LinkItem>
          <Anchor
            target="_blank"
            href="https://www.sparebank1.no/nb/bv/privat.html"
          >
            <Box height={isMobile ? 'xsmall' : 'small'} width={isMobile ? 'xsmall' : 'small'}>
              <Image fit="contain" src={SponsorLogo} />
            </Box>
          </Anchor>
        </Box>
      </Box>
      {!isMobile && (
        <Box direction="row" pad="medium">
          {appRouteItems.map(({ route, label, content }: any) => (
            <Box pad="medium" key={label}>
              <LinkItem
                route={route}
                label={label}
                size="medium"
                margin="none"
                color="#002776"
              />
              {content && (
                <Box>
                  {content.map((item: any) => (
                    <StyledLinkItem
                      key={item.label}
                      route={`${route}${item.route}`}
                      label={item.label}
                      margin="none"
                      size="xsmall"
                    />
                  ))}
                </Box>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Footer>
  );
};

export default ContentFooter;
